import type { UseQueryResult } from "@tanstack/react-query";

import { useOrgScopedQuery } from "../../query/scope";
import { getRepoHostTokens, type RepoHostTokensResponse } from "./tokensApi";

// Хук для GET /tokens — список токенов ролей текущей org. Org-scoped
// запрос (см. `src/query/scope.ts`).
export function useRepoHostTokens(): UseQueryResult<
  RepoHostTokensResponse,
  Error
> {
  return useOrgScopedQuery<RepoHostTokensResponse>({
    key: ["connections", "forgejo", "tokens"],
    queryFn: () => getRepoHostTokens(),
    retry: false,
  });
}
